import React from 'react';

function ReconnectMenuIcon() {
  return (
    <svg
      width='16px'
      height='16px'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17 18.8742C19.1213 17.3287 20.5 14.8251 20.5 11.9996C20.5 7.30519 16.6944 3.49961 12 3.49961H11.5M12 20.4996C7.30558 20.4996 3.5 16.694 3.5 11.9996C3.5 9.17407 4.87867 6.67054 7 5.12501M11 22.3996L13 20.3996L11 18.3996M13 5.59961L11 3.59961L13 1.59961'
        stroke='#404040'
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}

export default ReconnectMenuIcon;
